import { GridColDef } from '@mui/x-data-grid-pro';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';
import { IFacility, IFacilityGroup, IPage } from 'common/src/types/interfaces';

import {
  deleteFacilityGroup,
  getFacilityGroups,
} from 'portal/src/api/FacilityGroupsService';
import { NEW_ID } from 'portal/src/constants/ReservedIDs';

import DataTable from '../common/DataTable';
import addNumberColumnProps from '../common/tables/addNumberColumnProps';

const FacilityGroups = () => {
  const navigate = useNavigate();

  const {
    data: facilityGroups,
    isFetching,
    isError,
    refetch,
  } = useQuery({
    queryKey: ['facilityGroups'],
    queryFn: async () => await getFacilityGroups(),
    initialData: { data: [] } as IPage<IFacilityGroup>,
  });

  const gridColumns: GridColDef[] = [
    { field: 'name', headerName: 'Facility Group', flex: 1 },
    {
      field: 'facilities',
      flex: 0.5,
      valueGetter: (value: IFacility[]) => value?.length ?? 0,
      ...addNumberColumnProps('Number Of Facilities Per Group', true),
    },
  ];

  const handleNavigate = (id: string) => navigate(`./${id}`);

  return (
    <DataTable
      actionsConfig={{
        readActionConfig: {
          onClick: (id) => handleNavigate(id),
        },
        deleteConfig: {
          targetStr: 'facility group',
          onDeleteClick: async (id) => {
            await deleteFacilityGroup(id);
            await refetch();
          },
          snackbarMsgKey: 'FACILITY_GROUP',
        },
      }}
      columns={gridColumns}
      contextName={NESTED_ROUTES.ADMINISTRATION.FACILITY_GROUPS}
      dataFetchError={isError}
      loading={isFetching}
      rows={facilityGroups.data}
      toolbarSlotProps={{
        exportFileName: 'facility_groups',
        onNewButtonClick: () => handleNavigate(NEW_ID),
        showFilters: true,
      }}
    />
  );
};

export default FacilityGroups;
